<template>
  <v-text-field
      :id="inputName"
      :value="inputValue"
      :label="label"
      @focus="onInputFocus"
      @input="onInputChange"
      outlined
      class="text-h6"
      readonly
  />
</template>

<script>
export default {
  name: "InputComponent",
  props: {
    inputs: {
      type: Object
    },
    inputName: {
      type: String
    },
    label: {
      type: String
    }
  },
  methods: {
    onInputChange(input) {
      this.$emit("onInputChange", input);
    },
    onInputFocus(input) {
      this.$emit("onInputFocus", input);
    },
    getLabel() {
      return (this.inputName === 'momName') ?  "ماں کا نام" : "بچے کا نام"
    }
  },
  computed: {
    inputValue: function () {
      return this.inputs[this.inputName];
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>